const useStyledReportColumns = (columns) => {
  return columns.map((col) => ({
    ...col,
    onHeaderCell: () => ({
      // style: { backgroundColor: "#f0f2f5", fontWeight: "bold" },
      style: {
        backgroundColor: "#e2e5e2",
        fontWeight: "bold",
        color: "#000",
      },
    }),
  }));
};

export default useStyledReportColumns;
